import { Text, View } from 'react-native'

import { styled } from '~/core/styled'

import { convertLineHeight } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      paddingHorizontal: theme.paddingInsetOnepulse,
      paddingVertical: theme.paddingInsetNone,

      backgroundColor: 'transparent',
    },
  }
})

export const ContentText = styled(Text, theme => {
  return {
    base: {
      fontSize: theme.fontSizeThreeandhalfpulse,
      fontFamily: theme.fontFamily.regular,
      color: theme.colorTextNeutralDefault,

      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {
      size: {
        md: {
          height: theme.sizingExtrasmall,

          fontSize: theme.fontSizeThreepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreepulse,
            theme.lineHeightSmall
          ),
        },
        ml: {},
        lg: {},
        xl: {},
      },
      isDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      isReadOnly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    },
  }
})
